import { get, post, del, put } from '../request';

export async function fetchUsers(
  { userService },
  authenticationToken,
  userType,
) {
  let url = `${userService}/trueprodigy/users?includeInactive=true`;
  if (userType) {
    url += `&userType=${userType}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function setUsersReadOnly(
  { userService },
  authenticationToken,
  { payload },
) {
  let url = `${userService}/trueprodigy/users/readonly`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function setUsersForceLogOff(
  { userService },
  authenticationToken,
  { payload },
) {
  let url = `${userService}/trueprodigy/users/forcelogoff`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function inActivateUser(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/inactivate`;
  const { body } = await put(authenticationToken, url, {
    contentType: 'multipart/form-data;',
  });
  return body;
}

export async function activateUser(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/activate`;
  const { body } = await put(authenticationToken, url, {
    contentType: 'multipart/form-data;',
  });
  return body;
}

export async function createUser(
  { userService },
  authenticationToken,
  { email, fullName, userType },
) {
  const url = `${userService}/trueprodigy/users`;
  const { body } = await post(authenticationToken, url, {
    email,
    fullName,
    userType,
  });
  return body;
}

export async function massCreateUsers(
  { userService },
  authenticationToken,
  { payload },
) {
  const url = `${userService}/trueprodigy/user/masscreate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteUser(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/deletepublic`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateUser(
  { userService },
  authenticationToken,
  { userId, userData },
) {
  const url = `${userService}/trueprodigy/user/${userId}`;
  const { body } = await put(authenticationToken, url, userData);
  return body;
}

export async function fetchUserModules(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/modules`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function assignUserModule(
  { userService },
  authenticationToken,
  { userId, module },
) {
  const url = `${userService}/trueprodigy/user/${userId}/module/${module.id}`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function deleteUserModule(
  { userService },
  authenticationToken,
  { userId, moduleId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/module/${moduleId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchUserRoles(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/roles`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addUserModuleRole(
  { userService },
  authenticationToken,
  { userId, moduleId, roleId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/module/${moduleId}/roles`;
  const { body } = await post(authenticationToken, url, {
    roleIDList: [roleId],
  });
  return body;
}

export async function deleteUserModuleRole(
  { userService },
  authenticationToken,
  { userId, moduleId, roleId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/module/${moduleId}/role/${roleId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function initUser(
  { userService },
  authenticationToken,
  { userId, redirectUrl, messageType },
) {
  const url = `${userService}/trueprodigy/user/${userId}/inituser`;
  const { body } = await post(authenticationToken, url, {
    url: redirectUrl,
    messageType,
  });
  return body;
}

export async function fetchTaxingUnits(
  { taxingUnitService },
  authenticationToken,
) {
  const url = `${taxingUnitService}/taxingunit/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchUserTaxingUnits(
  { userService },
  authenticationToken,
  { userId, moduleId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/module/${moduleId}/config/taxingUnits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateUserTaxingUnits(
  { userService },
  authenticationToken,
  { userId, moduleId, configItems },
) {
  const url = `${userService}/trueprodigy/user/${userId}/module/${moduleId}/config/taxingUnits`;
  const { body } = await put(authenticationToken, url, { configItems });
  return body;
}

export async function fetchUserSearchCriteria(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/trueprodigy/user/searchcriteria`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAllTaxingUnits(
  { taxingUnitService },
  authenticationToken,
) {
  const url = `${taxingUnitService}/taxingunit/taxingunitsummary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchUsersByFilters(
  { userService },
  authenticationToken,
  { userType, filters, page = 1, pageSize = 50 },
) {
  const url = `${userService}/trueprodigy/user/search/${userType}?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(authenticationToken, url, filters);
  return body;
}

export async function getUserSummary(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/summary`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getUserAttributeAssoc(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/attributeassocs`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getSystemAttributes(
  { userService },
  authenticationToken,
) {
  const url = `${userService}/trueprodigy/userattributes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertUserAttributeAssoc(
  { userService },
  authenticationToken,
  { userId, payload },
) {
  const url = `${userService}/trueprodigy/user/${userId}/attributeassocs`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteUserAttributeAssoc(
  { userService },
  authenticationToken,
  { userAttributeAssocID },
) {
  const url = `${userService}/trueprodigy/userattributeassoc/${userAttributeAssocID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function validatePublicPortalUser(
  { userService },
  authenticationToken,
  { userID },
) {
  const url = `${userService}/trueprodigy/users/public/validateuser/${userID}`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function setPublicAgent(
  { userService },
  authenticationToken,
  { userId, payload },
) {
  const url = `${userService}/trueprodigy/user/${userId}/publicagentset`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function clearPublicAgent(
  { userService },
  authenticationToken,
  { userId },
) {
  const url = `${userService}/trueprodigy/user/${userId}/publicagentclear`;
  const { body } = await put(authenticationToken, url);
  return body;
}
